import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdInsights,
  MdPeople,
  MdBusiness,
  MdDevices,
  MdSettings,
  MdAnalytics,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import Users from 'views/admin/users';
import Analytics from 'views/admin/analytics';
import Company from 'views/admin/company';
import Device from 'views/admin/device';
import Dashboard from 'views/admin/dashboard';
import Automation from 'views/admin/automation';
import SignupContainer from 'views/auth/signup/SignupContainer';
import DeletedLogs from 'views/admin/deletedLogs';
import Prediction from 'views/admin/prediction';
import { AiOutlineWarning } from 'react-icons/ai';
// import Analytics from 'views/admin/analytics';

const allRoutes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
  },

  {
    name: 'Automation',
    layout: '/admin',
    path: '/automation',
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: <Automation />,
  },
  // {
  //   name: 'Analytics',
  //   layout: '/admin',
  //   path: '/analytics',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   component: <Analytics />,
  //   secondary: true,
  // },

  {
    name: 'Analytics',
    layout: '/admin',
    path: '/analytics',
    icon: <Icon as={MdInsights} width="20px" height="20px" color="inherit" />,
    component: <Analytics />,
    secondary: true,
  },
  {
    name: 'Smart AI Monitoring',
    layout: '/admin',
    path: '/smart-ai-monitoring',
    icon: <Icon as={MdAnalytics} width="20px" height="20px" color="inherit" />,
    component: <Prediction />,
    secondary: true,
  },
  {
    name: 'Company',
    layout: '/admin',
    path: '/company',
    icon: <Icon as={MdBusiness} width="20px" height="20px" color="inherit" />,
    component: <Company />,
    secondary: true,
  },

  {
    name: 'create-company',
    layout: '/auth',
    path: '/create-company',
    icon: <Icon as={MdBusiness} width="20px" height="20px" color="inherit" />,
    component: <SignupContainer />,
    secondary: true,
  },

  {
    name: 'Devices',
    layout: '/admin',
    path: '/devices',
    icon: <Icon as={MdDevices} width="20px" height="20px" color="inherit" />,
    component: <Device />,
    secondary: true,
  },
  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <Users />,
    secondary: true,
  },
  // {
  //   name: 'MainDashboard',
  //   layout: '/admin',
  //   path: '/main-dashboard',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: <MainDashboard />,
  // },
  // {
  //   name: 'Data Tables',
  //   layout: '/admin',
  //   icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
  //   path: '/data-tables',
  //   component: <DataTables />,
  // },
  // {
  //   name: 'Deleted Logs',
  //   layout: '/admin',
  //   path: '/deleted-logs',
  //   icon: (
  //     <Icon as={AiOutlineWarning} width="20px" height="20px" color="inherit" />
  //   ),
  //   component: <DeletedLogs />,
  // },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Profile />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
];

const getFilteredRoutes = () => {
  const role = localStorage.getItem('role');

  if (role === 'companyUser') {
    return allRoutes.filter((route) =>
      [
        'Dashboard',
        'Automation',
        'Analytics',
        'Smart AI Monitoring',
        'Users',
        'Profile',
        'Company',
        'Devices',
      ].includes(route.name),
    );
  }

  if (role === 'user') {
    return allRoutes.filter((route) =>
      [
        'Dashboard',
        'Automation',
        'Analytics',
        'Smart AI Monitoring',
        'Profile',
        'Company',
        'Devices',
      ].includes(route.name),
    );
  }

  if (role === 'baseuser') {
    return allRoutes.filter((route) =>
      ['Analytics', 'Profile', 'Smart AI Monitoring'].includes(route.name),
    );
  }

  return allRoutes;
};

const routes = getFilteredRoutes();
export default routes;
